import { DonutChartDatum } from '@quality24/design-system';

/**
 * Maps the data to a Pie chart in the format:
 * {
 *   id: entry.key
 *   label: entry.key
 *   value: entry.value
 * }
 */
export const formatChartData = (
  data: Array<Record<string, string | number>>,
  target = 0,
): Array<DonutChartDatum> => {
  const chartValue = data.reduce(
    (result, d) =>
      result +
      Object.entries(d)
        .filter(([k]) => k !== '_original')
        .reduce((acc, [, value]) => acc + Math.round(value as number), 0),
    0,
  );

  const remaining = Math.max(0, Math.round(target - chartValue));

  return [
    {
      id: 'value',
      label: 'Valor',
      value: chartValue,
    },
    {
      id: 'remaining',
      label: 'Restante',
      value: remaining,
    },
  ];
};
